// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2QPh9","question":"styles_question__2ZIJy","inputVisibleButton":"styles_inputVisibleButton__2tEwr","note":"styles_note__2n-1z"};